import React from 'react';
import './PatentCard.css';

const formatDate = (yyyymmdd) => {
  if (!yyyymmdd || yyyymmdd.length < 8) return yyyymmdd || '';
  return `${yyyymmdd.slice(6, 8)}/${yyyymmdd.slice(4, 6)}/${yyyymmdd.slice(0, 4)}`;
};

const PatentCard = ({ patent, onClick }) => {
  if (!patent) return null;

  const title = patent.title_en || patent.title || '';
  const headline = patent.headline || patent.summary || '';
  const applicants = Array.isArray(patent.applicants) ? patent.applicants.join(', ') : '';

  return (
    <div className="patent-card" onClick={() => onClick && onClick(patent)}>
      {/* Preview Image */}
      {patent.preview_image && (
        <div className="patent-card-image">
          <img
            src={patent.preview_image}
            alt={title || 'Patent'}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://via.placeholder.com/400x300?text=Image+unavailable';
            }}
          />
        </div>
      )}

      {/* Card Content */}
      <div className="patent-card-content">
        {/* Title */}
        <h3 className="patent-card-title">{title}</h3>

        {/* Headline */}
        {headline && (
          <p className="patent-card-headline">{headline}</p>
        )}

        {/* Metadata Tags */}
        <div className="patent-card-meta">
          {applicants && (
            <span className="patent-meta-tag tag-applicant">{applicants}</span>
          )}
          {patent.category && (
            <span className="patent-meta-tag tag-domain">{patent.category}</span>
          )}
          {patent.publication_date && (
            <span className="patent-meta-tag tag-date">{formatDate(patent.publication_date)}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatentCard;
